import 'public-path';
import $ from 'cash-dom';

import ArticlePageController from 'controllers/ArticlePageController';
import ApplicationEntrypoint from 'entrypoints/ApplicationEntrypoint';
import store from 'state';

class ArticlePageEntrypoint extends ApplicationEntrypoint {
  static async init() {
    await super.init(store);

    ArticlePageController.init(store);
  }
}

/* istanbul ignore next */
$(document).ready(async () => {
  await ArticlePageEntrypoint.init();
  ArticlePageEntrypoint.removeLoader();
});

export default ArticlePageEntrypoint;
